/**
 * Simple SupplyPoint Test Suite Entry Point
 * mvp-feeder branch için proof of concept test'leri
 */

import { SimpleSupplyPointTest } from './SimpleSupplyPointTest';
import { createTestSimpleSupplyPoint } from '../types/SimpleSupplyPoint';
import { transformSimpleSupplyToYC_Data, transformSimpleSupplyToVoltageDropData } from '../utils/simpleTransformFunctions';

/**
 * Browser console'da kullanılacak test runner
 */
export function runSimpleSupplyPointTests() {
  
  

  // Ana test suite'i çalıştır
  const testResults = SimpleSupplyPointTest.runAllTests();

  if (testResults.success) {
    
    

    // Document transform test'leri
    const testData = createTestSimpleSupplyPoint();

    // Yükleme Cetveli transform test
    
    const ycData = transformSimpleSupplyToYC_Data(testData);
    
    ycData.slice(0, 3).forEach(item => {
      
    });

    // Gerilim Düşümü transform test
    
    const voltageData = transformSimpleSupplyToVoltageDropData(testData);
    
    voltageData.forEach(item => {
      
    });

    
    
    
    
    
    

    return {
      success: true,
      testResults,
      documentTests: {
        ycData: ycData.length,
        voltageData: voltageData.length
      }
    };
  } else {
    console.error("❌ PROOF OF CONCEPT FAILED");
    return testResults;
  }
}

/**
 * Performance comparison test
 */
export function comparePerformanceWithLegacy() {
  
  

  const testData = createTestSimpleSupplyPoint();

  // Simple system performance
  const simpleStart = performance.now();
  for (let i = 0; i < 1000; i++) {
    transformSimpleSupplyToYC_Data(testData);
  }
  const simpleEnd = performance.now();
  const simpleTime = simpleEnd - simpleStart;

  
  
  
  

  return {
    simpleTime,
    avgPerTransform: simpleTime / 1000
  };
}

// Browser global exports
if (typeof window !== 'undefined') {
  window.runSimpleSupplyPointTests = runSimpleSupplyPointTests;
  window.comparePerformanceWithLegacy = comparePerformanceWithLegacy;
  window.SimpleSupplyPointTest = SimpleSupplyPointTest;

  // Auto-run on load (development)
  if (window.location.hostname === 'localhost') {
    
   }
}

export { SimpleSupplyPointTest };